import { render, staticRenderFns } from "./ProfileMeta.vue?vue&type=template&id=6d181e77"
import script from "./ProfileMeta.vue?vue&type=script&lang=ts"
export * from "./ProfileMeta.vue?vue&type=script&lang=ts"
import style0 from "./ProfileMeta.vue?vue&type=style&index=0&id=6d181e77&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports